/**
 * Avalara © 2019
 * file: engines/opus_ui/src/StatusItem.js
 */

import axios from 'axios';
import React, { Component } from 'react';
import './StatusItem.css';
import envMappings from '../utils/envMappings';
import { utc } from 'moment';
import { DEPRECATED_ENGINES } from '../constants/Engines';

class StatusItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      version: '',
      packagedTime: '',
      fetching: false,
      hover: false,
      isDeprecated: false
    };
  }

  componentDidMount() {
    this.fetchStatus(this.props);
  }

  async fetchStatus(props) {
    this.setState({
      fetching: true,
    });
    const { env, engine } = props;
    if (DEPRECATED_ENGINES.includes(engine)) {
      this.setState({
        fetching: false,
        isDeprecated: true
      });
      return;
    }

    const data = await this.pingHealthCheck({ env, engine });
    if (data) {
      this.setState({
        fetching: false,
        status: data.status,
        version: data.data ? data.data.version : '',
        packagedTime: data.data
          ? utc(
              data.data.version.match(/(20\d{2}\d{4}\.\d{6})/)[1],
              'YYYYMMDD.HHmmss'
            )
          : '',
      });
    }
  }

  pingHealthCheck({ env, engine }) {
    let url = envMappings[env].url;
    if (engine === 'account') {
      url = `${url}/api/v1`;
    }
    return axios
      .get(`${url}/${engine}/health-check`, {
        validateStatus: () => true,
        crossdomain: true,
      })
      .then(({ status, data }) => {
        return { status, data };
      });
  }

  statusColor() {
    let className;
    if (this.state.fetching) {
      className = 'statusItem fetching';
      return className;
    }

    if (this.state.isDeprecated) {
      className = 'statusItem deprecated';
      return className;
    }

    if (this.state.status !== 200) {
      return (className = 'statusItem bad');
    }

    return (className = 'statusItem good');
  }

  render() {
    return (
      <div className={this.statusColor()}>
        {this.state.fetching && <h1 className="labelTitle">Fetching</h1>}
        {!this.state.fetching && this.state.status === 200 && (
          <React.Fragment>
            <div className="info">
              <p>{this.state.version}</p>
            </div>
            <span
              className="packaged-time"
              title={this.state.packagedTime.toISOString()}
            >
              {this.state.packagedTime.local().calendar()}
            </span>
          </React.Fragment>
        )}
        {!this.state.fetching && this.state.isDeprecated && (
          <h2 className="deprecatedTitle"> Deprecated !!</h2>
        )}
        {!this.state.fetching &&
          !this.state.isDeprecated &&
          this.state.status !== 200 && (
            <h1 className="title">Status: {this.state.status} </h1>
          )}
      </div>
    );
  }
}

export default StatusItem;
